import { FunctionComponent } from 'react';

import { Box, Tooltip, Typography, TypographyProps } from '@mui/material';

import { IUnifiedTeacherNote } from '@dw/models/teacherNote';
import { buildTeacherNoteDirectionLabel } from '@dw/utils';

interface ITeacherNoteDirectionLabelProps {
  note: IUnifiedTeacherNote;
  variant?: TypographyProps['variant'];
  fontWeight?: TypographyProps['fontWeight'];
}

/**
 * Who the conversation is with. The label truncates a group note's recipients to "Name +4", so it
 * carries a tooltip spelling them all out — shared by the rail row and the open note's header so
 * the two can never drift.
 */
export const TeacherNoteDirectionLabel: FunctionComponent<ITeacherNoteDirectionLabelProps> = (props: ITeacherNoteDirectionLabelProps) => {

  const { note, variant = 'body2', fontWeight } = props;

  // Only worth a tooltip once the label starts hiding names behind a "+n".
  const recipientNames = note.recipients && note.recipients.length > 1
    ? note.recipients.map(x => x.name).join('\n')
    : undefined;

  return (
    <Tooltip title={recipientNames ? <Box sx={{ whiteSpace: 'pre-line' }}>{recipientNames}</Box> : ''}>
      <Typography variant={variant} noWrap fontWeight={fontWeight}>
        {buildTeacherNoteDirectionLabel(note)}
      </Typography>
    </Tooltip>
  );
};
